import { render } from "./BusinessPartnerProfile.vue?vue&type=template&id=4c81c53e&scoped=true"
import script from "./BusinessPartnerProfile.vue?vue&type=script&lang=js"
export * from "./BusinessPartnerProfile.vue?vue&type=script&lang=js"

import "./BusinessPartnerProfile.vue?vue&type=style&index=0&id=4c81c53e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c81c53e"]])

export default __exports__